<template>
    <!-- <div v-if="value" class="rotate-scale-up"> -->
    <div v-if="value" class="">
        <EspError icon="mdi-check-decagram" :iconColor="iconColor" text=""/>
    </div>
</template>

<script>
    import EspError from './EspError.vue'
    export default {
        components:{
            EspError
        },
        props:{
            value:{
                type:Boolean,
                default:false
            },
            iconColor:{
                type:String
            }
        },
        methods: {
            
        },  
    }
</script>

<style lang="scss" scoped>

.rotate-scale-up {
	-webkit-animation: rotate-scale-up 0.65s linear both;
            animation: rotate-scale-up 0.65s linear both;
}

@-webkit-keyframes rotate-scale-up {
  0% {
    -webkit-transform: scale(1) rotateZ(0);
            transform: scale(1) rotateZ(0);
  }
  50% {
    -webkit-transform: scale(2) rotateZ(180deg);
            transform: scale(2) rotateZ(180deg);
  }
  100% {
    -webkit-transform: scale(1) rotateZ(360deg);
            transform: scale(1) rotateZ(360deg);
  }
}
@keyframes rotate-scale-up {
  0% {
    -webkit-transform: scale(1) rotateZ(0);
            transform: scale(1) rotateZ(0);
  }
  50% {
    -webkit-transform: scale(2) rotateZ(180deg);
            transform: scale(2) rotateZ(180deg);
  }
  100% {
    -webkit-transform: scale(1) rotateZ(360deg);
            transform: scale(1) rotateZ(360deg);
  }
}

</style>